<div id="screen"></div>
<div id="dlg">
  <form #userForm="ngForm" name='asdf'>
    <div id="caption">
      <h2>{{userNameOrNew}}
        <div role="button" (click)="onCancel()"><span class="cvt-icon-closeDelete"></span>
        </div>
      </h2>
    </div>
    <div id="content">
      <h5>User Contact Information</h5>
      <div id="userContact">
        <div id="linkedUser">
          <label *ngIf="!userLinked">Link User </label>
          <kendo-dropdownlist id="ddlLinkedUser" [data]="UserList" style="width:70%"  *ngIf="!userLinked"
            [(ngModel)]="UserName" #CustomerName="ngModel"  name ="UserName" valueField="UserName" textField="UserName" [valuePrimitive]="true"
            (selectionChange)="linkedUser_selectionChange($event)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>{{dataItem?.UserName}}</span>
            </ng-template>
          </kendo-dropdownlist>
        </div>
        <div class="double-up">
          <div><label class="app-required" for="firstName">First Name</label><input id="firstName" name="firstName" type="text"
              maxlength="100" [(ngModel)]="user.FirstName" [disabled]="firstName" [attr.class]="testValidPullClass(firstName)"
              #firstName="ngModel" required /></div>
          <div><label class="app-required" for="LastName">Last Name</label><input id="LastName" type="text" maxlength="100" name='LastName'
              [(ngModel)]="user.LastName"  [disabled]="LastName" [attr.class]="testValidPullClass(LastName)" #LastName="ngModel"  /></div>
        </div>
        <div><label class="app-required" for="eMail">E-mail</label>
          <input id="eMail" type="text" maxlength="256" [disabled]="eMail" [(ngModel)]="user.EMailAddress" name='eMail' [attr.class]="testValidPullClass(eMail)" #eMail="ngModel"
          required pattern="^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$" /></div>
      </div>
      <h5>Login Information</h5>
      <div id="loginInfo">
        <div class="col">
          <div><label class="app-required" for="userNameNm">Login Name</label><input id="userNameId" type="text" maxlength="256" name="userNameNm"
              [(ngModel)]="user.UserName" [attr.class]="testValidPullClass(userNameNg)" [disabled]="userID !== ''"  #userNameNg="ngModel" required (blur)="onBlurUserName($event)" /></div>
          <div><label for="accessLevel">Access Level</label>
            <kendo-dropdownlist id="accessLevel" name="accessLevel" [data]="accessList" [(ngModel)]="user.SecurityRole" valueField="id"
              textField="desc" [valuePrimitive]="true" [allowCustom]="true" [popupSettings]="accessLevelDropdownPopupSettings">
              <ng-template kendoDropDownListValueTemplate let-dataItem>
                <span class="boldFont">{{dataItem?.desc}}</span>
              </ng-template>
              <ng-template kendoDropDownListItemTemplate let-dataItem>
                <span class="change-account-item">{{dataItem.desc}}</span>
              </ng-template>
            </kendo-dropdownlist>
          </div>
        </div>
      </div>
    </div>
    <div id="buttons">
      <div>
        <button class="k-button cvt-primary" (click)="onSaveUser()">Save User</button>
        <button class="k-button cvt-secondary" (click)="onCancel()">Cancel</button>
      </div>
    </div>

  </form>
</div>
<app-modal (onOkToParent)='okCloseButtonClick(true)' (onCloseToParent)='okCloseButtonClick(false)' *ngIf='openModal' [dialogTitle]="dialogTitle"
  [dialogTextLine1]="dialogTextLine1" [dialogTextLine2]="dialogTextLine2" [primaryButtonText]="'OK'" [secondaryButtonText]="cancelButton">
</app-modal>
<app-spinner [isBusy]="isBusy"></app-spinner>
